<template>
	
	<div class="row">
	
		<!-- Profile Info and Notifications -->
		<div class="col-md-1 col-sm-8 clearfix">
	
			<ul class="user-info pull-left pull-none-xsm">
	
				<!-- Profile Info -->
				<li class="profile-info dropdown"><!-- add class "pull-right" if you want to place this from right -->
					<a href="#" class="dropdown-toggle" data-toggle="dropdown">
						<img :src="profile()" alt="" class="img-circle" width="44" />
						{{this.$parent.user.name}}
					</a>
					<ul class="dropdown-menu">
						<!-- Reverse Caret -->
						<li class="caret"></li>
						<!-- Profile sub-links -->
						<li><router-link to="/profile/"><i class="fa fa-edit"></i> Editar perfil</router-link></li>
					</ul>
				</li>
	
			</ul>
	
		</div>
		<div class="col-md-3 col-sm-4 clearfix hidden-xs">
			<input class="form-control" v-model="search" placeholder="Buscar paciente"> 
		</div>
		<div class="col-md-5 col-sm-4 clearfix hidden-xs">
			 <a class="btn btn-info btn-sm" @click="toSearch"><i class="fa fa-search"></i></a>
		</div>
		<!-- Raw Links -->
		<div class="col-md-3 col-sm-4 clearfix hidden-xs">
			<ul class="list-inline links-list pull-right">	
				<li><router-link class="btn btn-info btn-sm" style="background-color: #d01519;border: #d01519;" :to="'/patients/edit'"><i class="fa fa-plus"></i> Paciente</router-link></li>
				<li><router-link class="btn btn-info btn-sm" style="background-color: #2b4162e6;border: #2b4162e6;" :to="'/appointments/edit'"><i class="fa fa-plus"></i> Cita</router-link></li>
				<li><a @click="$root.handleLogout">Cerrar session <i class="entypo-logout right"></i></a></li>
			</ul>
		</div>
		
		<loader style="position: fixed;z-index: 10000;" v-if="$root.isLoading == true" object="#2b4162e6" color1="#d01519" color2="#ffffff" size="5" speed="2" bg="#343a40" objectbg="#999793" opacity="80" disableScrolling="false" name="circular"></loader>
	
	</div>
	
</template>

<script type="text/javascript">
	export default {
		data(){
			return {
				search:null,
			}
		},

		methods:{
			profile(){
				return ('https://ui-avatars.com/api/?name='+this.$parent.user.name+'&size=256');
			},
			toSearch(){
				this.$router.push('/patients?keywords='+this.search);
            },
		}
    }
</script>
<style>
.custom-toast {
	
  font-size: 15px; /* Cambia el tamaño de la fuente */
}
</style>